import * as tslib_1 from "tslib";
import { throwError as observableThrowError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseService } from "../base.service";
var OnboardService = /** @class */ (function (_super) {
    tslib_1.__extends(OnboardService, _super);
    function OnboardService(http) {
        var _this = _super.call(this, 'onboard', http) || this;
        _this.http = http;
        return _this;
    }
    OnboardService.prototype.ngOnInit = function () {
    };
    OnboardService.prototype.getOnboardByOrgId = function (id) {
        // return this.http.get(`${this.url}/getByOrgId/${id}?${this.embeddedStr}`)
        //     .map((response) => response).catch((res: any) => Observable.throw(res));
        return this.http.get(this.url + "?f_organisation.id=" + id + "&f_organisation.id_op==&embedded=organisation").pipe(map(function (resp) { return resp; }), catchError(function (res) { return observableThrowError(res); }));
    };
    return OnboardService;
}(BaseService));
export { OnboardService };
